module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (227).6fb79867.jpg";